module.exports = __webpack_public_path__ + "templates.store_pick_up_options-a5a5a2d9.html";